import classes from "./Layout.module.css";

import evityLogo from "../../images/evity/evityLogo.png";
import React from "react";

interface Props {
  children: any;
  customPadding?: number;
  customHeight?: string;
  isDarkTheme?: boolean;
  isEvityReport?: boolean;
  dataAgentTarget?: string;
}

const Layout = ({
  children,
  customPadding,
  customHeight,
  isDarkTheme,
  dataAgentTarget,
  isEvityReport,
}: Props): JSX.Element => {
  return (
    <div
      data-agent-target={dataAgentTarget}
      className={classes.container}
      style={
        isDarkTheme
          ? {
              padding: customPadding,
              backgroundColor: "var(--NEUTRAL_BG_MAIN)",
              borderBottom: "1px solid var(--NEUTRAL_BG_MAIN)",
            }
          : { padding: customPadding, height: customHeight }
      }
    >
      {children}
      {isEvityReport && (
        <img
          className={classes.evityLogo}
          src={evityLogo}
          alt="image of the Evity welness"
        />
      )}
    </div>
  );
};

export default Layout;
